import { render, staticRenderFns } from "./component-chat.vue?vue&type=template&id=d22e04ac&scoped=true&"
import script from "./component-chat.vue?vue&type=script&lang=js&"
export * from "./component-chat.vue?vue&type=script&lang=js&"
import style0 from "./component-chat.vue?vue&type=style&index=0&id=d22e04ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22e04ac",
  null
  
)

export default component.exports